import { render, staticRenderFns } from "./AddPikYugPrice.vue?vue&type=template&id=58344a34&scoped=true"
import script from "./AddPikYugPrice.vue?vue&type=script&lang=js"
export * from "./AddPikYugPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58344a34",
  null
  
)

export default component.exports